<template>
    <main class="main">
        <div class="container">
            <div class="row row-cols-1 row-cols-md-2 services-lead">
                <div class="col">
                    <h2 class="h2 services-heading">Korzystaj z raportów</h2>
                    <p class="services-lead-text d-sm-block d-none">
                        Dzięki Raportom możesz cyklicznie sprawdzać stan swoich
                        promocji w swoich sklepach.
                    </p>
                </div>
            </div>
            <div v-if="reports" class="row row-cols-1 row-cols-md-2">
                <div
                    class="col mt-4"
                    v-for="(report, idx) in reports"
                    :key="idx"
                >
                    <div class="c-service is-featured">
                        <div class="row flex-column flex-lg-row h-100">
                            <div class="c-service-content col-lg-12">
                                <h2 class="c-service-heading h5 mt-0">
                                    {{ report.heading }}
                                </h2>

                                <div class="c-service-text">
                                    <p>{{ report.description }}</p>
                                </div>

                                <div class="c-service-actions">
                                    <div class="c-service-buttons mt-4">
                                        <button
                                            @click="
                                                e =>
                                                    onReportGenerateClick(
                                                        e,
                                                        report
                                                    )
                                            "
                                            class="btn btn-block btn-secondary"
                                        >
                                            Wygeneruj raport >
                                        </button>
                                    </div>
                                </div>
                                <lottery-info-container
                                    fontTiny
                                    v-if="isLotteryUser"
                                    class="pt-2"
                                    style="margin-bottom: -1.5rem"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <page-preloader v-else></page-preloader>
        </div>
    </main>
</template>

<script>
import LotteryInfoContainer from '@/components/lottery/LotteryInfoContainer.vue'

export default {
    name: 'Reports',
    components: { LotteryInfoContainer },
    computed: {
        services() {
            return this.$store.getters.getServices
        },
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        }
    },
    async created() {
        const reports = [
            {
                heading: 'Sprawdź użycia promocji w sklepach',
                description: 'Raport użycia promocji w sklepach.',
                moduleName: 'promoCompletions'
            },
            {
                heading: 'Sprawdź użycia promocji',
                description: 'Raport użycia promocji na kasach.',
                moduleName: 'promoUsage'
            },
            {
                heading:
                    'Sprawdź komunikację swoich urządzeń z systemem M/platform',
                description: 'Raport o stanie komunikacji kas.',
                moduleName: 'diagnostics'
            },
            // temporary disabled
            // {
            //     heading: 'Sprawdź raport PromoPlan',
            //     description:
            //         'Raport informujący o spełnieniu planów sprzedażowych i zadań specjalnych.',
            //     moduleName: 'reportPromoPlan'
            // },
            {
                heading: 'Sprawdź raport rozliczeniowy',
                description: 'Proste rozliczenie promocji.',
                moduleName: 'reportBillings'
            },
            // temporary disabled #1352
            // {
            //     heading: 'Sprawdź raport realizacji celów sprzedażowych',
            //     description:
            //         'Raport przedstawia stopień realizacji celów sprzedażowych.',
            //     moduleName: 'saleGoals'
            // },
            {
                heading: 'Sprawdź raport użyć zweryfikowanych negatywnie',
                description:
                    'Raport przedstawia szczegóły odrzuconych użyć promocji.',
                moduleName: 'invalidUsageProducts'
            }
        ]

        if (this.services) {
            const mKasaService = this.$store.getters.mKasaService
            if (mKasaService) {
                reports.push({
                    heading: 'Sprawdź raport M/kasa',
                    description: 'Raport M/kasa.',
                    moduleName: 'mKasa'
                })
            }
        }
        this.reports = reports
    },
    methods: {
        onReportGenerateClick(event, report) {
            this.$router.push({ name: report.moduleName })
        }
    },
    data() {
        return {
            reports: null
        }
    }
}
</script>
